import { createContext } from 'react';

export type AuthContextProps = {
  isAuthenticated: boolean;
  token: {
    get: () => string | null;
    save: (token: string) => void;
    clean: () => void;
  };
};

export const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);
